module.exports = __webpack_public_path__ + "img/titles9.f0913c0e.png";